export const port = '';
export const apiBaseUrl = process.env.REACT_APP_API_URL;
export const collectorsBaseUrl = process.env.REACT_APP_COLLECTORS_URL;
// export const apiBaseUrl = 'http://localhost:3000';
// export const collectorsBaseUrl = 'https://localhost:3001';
// export const apiBaseUrl = 'https://dev-api.wideview.io';
// export const collectorsBaseUrl = 'https://dev-collectors.wideview.io';
